<template>
    <div class="linea-pedido-param">
        <div class="linea-pedido-param-label">
            {{ title }}
        </div>
        <div class="linea-pedido-param-val">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "PedidoLineaParamPerfil",
    props: {
        title: {}
    }
}
</script>

<style scoped>
.linea-pedido-param-label {
    font-weight: bold;
}

.linea-pedido-param {
    flex: 1 1 50%;
}
</style>
